module.exports = __webpack_public_path__ + "static/media/de.75505d26.png";